import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/emergency-resources/components/EmergencyResourcesInteractive.tsx");
